import React from 'react';
import classnames from 'classnames';

import styles from './index.module.css';

interface EmptyAreaProperty {
	className?: string;
	svg?: string;
	title?: string;
	content?: string;
}

const EmptyArea: React.FC<EmptyAreaProperty> = ({ className, svg: Svg, title, content }) => (
	<div className={classnames(styles.emptyArea, className)}>
		{Svg && <Svg />}
		<h1>{title}</h1>
		<p>{content}</p>
	</div>
);

export default EmptyArea;
